import { httpClient } from '@/utils/http-client';
function parseDiscussionGuide(text) {
    if (typeof text !== 'string') {
        console.error('parseDiscussionGuide: text is not a string');
        return [];
    }
    const result = [];
    const splitText = text.split('\n');
    let partial = { type: '', content: '' };
    splitText.forEach(text => {
        if (text.includes('H1') || text.includes('h1') || text.includes('<pre><code>')) {
            partial = {
                type: 'header',
                content: text
                    .replaceAll('#', '')
                    .replaceAll('<pre>', '')
                    .replaceAll('</pre>', '')
                    .replaceAll('<code>', '<h1>')
                    .replaceAll('</code>', '</h1>')
            };
        }
        else if (text.includes('<p>') || text.includes('</p>')) {
            partial = {
                type: 'text',
                content: text
            };
        }
        else if ((text.includes('<li>') || text.includes('</li>')) && !text.startsWith('<li><ol')) {
            partial = {
                type: 'list',
                content: text
            };
        }
        else if (text.includes('</ul>') || text.includes('</ol>')) {
            partial = {
                type: 'break',
                content: text
            };
        }
        else {
            partial = {
                type: 'none',
                content: ''
            };
        }
        if (partial.content != '') {
            result.push(partial);
        }
    });
    return result;
}
/**
 * Serializes the discussion guide text to remove unneeded tags and let the parser handle it.
 * TODO: Fix API instead of doing this.
 * @param text - The text to serialize
 * @returns A serialized text string
 */
export const serializedDiscussionGuide = (text) => {
    return text
        .replaceAll('#', '')
        .replaceAll('<pre>', '')
        .replaceAll('</pre>', '')
        .replaceAll('<code>', '\n<h1>')
        .replaceAll('</code>', '</h1>');
};
export async function downloadDiscussionGuide(id) {
    if (typeof id !== 'number' || id < 0)
        throw 'id is invalid';
    const response = await httpClient.get(`/discussion-guides/${id}`);
    const text = response.data.result;
    if (typeof text !== 'string')
        throw 'subtitle text is not a string.';
    return { raw: text, discussionGuide: parseDiscussionGuide(text) };
}
export async function regenerateDiscussionGuide(id) {
    if (typeof id !== 'number' || id < 0)
        throw 'id is invalid';
    const response = await httpClient.get(`/discussion-guides/regenerate/${id}`);
    const text = response.data.result;
    if (typeof text !== 'string')
        throw 'subtitle text is not a string.';
    return { raw: text, discussionGuide: parseDiscussionGuide(text) };
}
